var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import gql from "graphql-tag";
export default (function (id, update) { return ({
    mutation: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    mutation removeSavedPropertyMutation($input: RemoveSavedPropertyInput!) {\n      removeSavedProperty(input: $input) {\n        propertyListing {\n          id\n          isStudentSaved\n        }\n      }\n    }\n  "], ["\n    mutation removeSavedPropertyMutation($input: RemoveSavedPropertyInput!) {\n      removeSavedProperty(input: $input) {\n        propertyListing {\n          id\n          isStudentSaved\n        }\n      }\n    }\n  "]))),
    variables: { input: { id: id } },
    optimisticResponse: {
        removeSavedProperty: {
            __typename: "RemoveSavedPropertyOutput",
            propertyListing: {
                __typename: "PropertyListing",
                id: id,
                isStudentSaved: false,
            },
        },
    },
    update: update,
}); });
var templateObject_1;
